import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from "rxjs";
import { IndexedStorageService } from './indexed-storage.service';

@Injectable({
    providedIn: 'root',
})
export class TranslateConfigService {
    private readonly langKey: string = 'lang';

    constructor(readonly translateService: TranslateService,
                readonly http: HttpClient,
                private indexedStorageService: IndexedStorageService) {
    }

    initLanguage(): Promise<any> {
        const savedLang = this.getCurrentLanguage();
        this.translateService.setDefaultLang(savedLang);
        this.translateService.use(savedLang);
        return firstValueFrom(this.translateService.use(savedLang));
    }

    changeLanguage(type: string) {
        localStorage.setItem(this.langKey, type);
        this.translateService.use(type);
    }

    getCurrentLanguage(): string {
        return localStorage.getItem(this.langKey) || 'en';
    }

    loadLanguages(): Observable<any> {
        return this.indexedStorageService.getLanguagesData();
    }

    clearCurrentLanguageCache(): Promise<void> {
        const currentLang = this.getCurrentLanguage();
        return this.indexedStorageService.clearCache(currentLang);
    }
}
